module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-no-page"
  }, [_c('div', {
    staticClass: "container no-padding"
  }, [_c('div', {
    staticClass: "no-page-content"
  }, [_c('div', {
    staticClass: "empty_state_logo"
  }, [_c('svg', {
    staticClass: "empty_state_svg",
    attrs: {
      "width": "32",
      "height": "24",
      "viewBox": "0 0 32 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M29 0H3C1.3125 0 0 1.375 0 3V21C0 22.6875 1.3125 24 3 24H29C30.625 24 32 22.6875 32 21V3C32 1.375 30.625 0 29 0ZM3 2H29C29.5 2 30 2.5 30 3V5.625C28.625 6.75 26.625 8.375 20.5625 13.1875C19.5 14.0625 17.4375 16.0625 16 16C14.5 16.0625 12.4375 14.0625 11.375 13.1875C5.3125 8.375 3.3125 6.75 2 5.625V3C2 2.5 2.4375 2 3 2ZM29 22H3C2.4375 22 2 21.5625 2 21V8.1875C3.375 9.375 5.625 11.1875 10.125 14.75C11.4375 15.8125 13.6875 18.0625 16 18C18.25 18.0625 20.5 15.8125 21.8125 14.75C26.3125 11.1875 28.5625 9.375 30 8.1875V21C30 21.5625 29.5 22 29 22Z",
      "fill": "#464B52"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "empty_state_text-content"
  }, [_c('div', {
    staticClass: "empty_state_title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('account.empty.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "empty_state_subtitle"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('account.empty.subtitle'))
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn empty_state_button--primary",
    attrs: {
      "href": _vm.knowSendLink,
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('account.empty.klicksend')) + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn empty_state_button",
    on: {
      "click": function($event) {
        _vm.modalOpen('edit-account');
        _vm.resetActiveAccount();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('account.empty.button')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f87ebde","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Account/components/EmptyBoard.vue
// module id = 276
// module chunks = 1